import { useHistoryClaims } from '@gik/api/users/claims';
import type { IUserProfileClaim } from '@gik/calendar/models/Claim';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import { useUserStore } from '@gik/core/store/UserStore';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { LoadingSpinner } from '@gik/ui-legacy/LoadingSpinner';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ClaimsList from './ClaimsList';
import ClaimsListSkeleton from './ClaimsListSkeleton';
import { translationKeys } from './i18n/en';

export interface IHistoryClaimsListProps {
  items?: IUserProfileClaim[];
}

const blockName = 'claimed-items-list';

function HistoryClaimsListComp({ items }: IHistoryClaimsListProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  const userStore = useUserStore();
  const { data: _items, error: _itemsError } = useHistoryClaims(userStore.id, {
    fallbackData: items,
  });

  const isLoading = !_items;
  const isError = isLoading && _itemsError;

  if (isLoading) return <LoadingSpinner center />;
  if (isError) return <LoadingSpinner center />;

  return (
    <ClaimsList className={bem()} items={_items} loading={!_items} emptyText={t(translationKeys.emptyHistoryClaims)} />
  );
}

export const HistoryClaimsList = withComponentErrorBoundary(withSuspense(HistoryClaimsListComp, ClaimsListSkeleton));
